import { Comprobante, ComprobanteNotificacion } from '../features/comprobantes/comprobantesAPI';
import automotorImg from '../assets/imponible-automotor.png';
import cementerioImg from '../assets/imponible-cementerio.png';
import comercioImg from '../assets/imponible-comercio.png';
import contribuyenteImg from '../assets/imponible-contribuyente.png';
import inmobiliarioImg from '../assets/imponible-inmobiliario.png';


export const esComprobanteComun = (comprobante: Comprobante | ComprobanteNotificacion): comprobante is Comprobante => {
  if (!('id_in' in comprobante)) {
    return true;
  }

  return false;
};

// eslint-disable-next-line max-len
export const esComprobanteNotif = (comprobante: Comprobante | ComprobanteNotificacion): comprobante is ComprobanteNotificacion => {
  if ('id_in' in comprobante) {
    return true;
  }

  return false;
};

export const getLabelTipoComprobante = (tipo: string) => {
  switch (tipo) {
    case 'ROD': return 'Rodado';
    case 'CEM': return 'Cementerio';
    case 'INM': return 'Inmueble';
    case 'COM': return 'Comercio';
    default: return 'Contribuyente';
  }
};

export const getLabelClaveComprobante = (tipo: string) => {
  switch (tipo) {
    case 'ROD': return 'Dominio';
    case 'CEM': return 'N° Nicho/Parcela';
    case 'INM': return 'N° Partida';
    case 'COM': return 'N° Comercio';
    default: return 'CUIT/CUIL';
  }
};

export const getImageComprobante = (tipo: string) => {
  switch (tipo) {
    case 'ROD': return automotorImg;
    case 'CEM': return cementerioImg;
    case 'INM': return inmobiliarioImg;
    case 'COM': return comercioImg;
    default: return contribuyenteImg;
  }
};

export const getTipoComprobante = (comprobante: Comprobante | ComprobanteNotificacion) => {
  switch (true) {
    case !!comprobante.nro_comercio: return 'COM';
    case !!comprobante.nro_inmueble: return 'INM';
    case !!comprobante.nro_rodado: return 'ROD';
    case !!comprobante.nro_cuenta: return 'CEM';
    default: return 'CON';
  }
};

export const getIdentificadorImponible = (comprobante: Comprobante | ComprobanteNotificacion) => {
  switch (true) {
    case !!comprobante.nro_comercio: return comprobante.nro_comercio;
    case !!comprobante.nro_inmueble: return comprobante.nro_inmueble;
    case !!comprobante.nro_rodado: return comprobante.nro_rodado;
    case !!comprobante.nro_cuenta: return comprobante.nro_cuenta;
    default: return comprobante.nro_contrib;
  }
};

export const convertBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      if (!fileReader.result) {
        reject(new Error('No se puede leer el archivo'));
        return;
      }

      if (typeof fileReader.result === 'string') {
        resolve(fileReader.result);
      } else {
        resolve(new Uint8Array(fileReader.result).toString());
      }
    };

    fileReader.onerror = error => {
      reject(error);
    };
  });
};
